import React from 'react'
import SliderVideo from '../../component/slidercomponent/SliderVideo'

const Video = () => {
    return (
        <>
            <div id="tie-block_3278" className="mag-box block-custom-content container" style={{ marginTop: "" }}>
                <div className="container-wrapper">
                    <div className="mag-box-title the-global-title">
                        <h3 className='title-semibold-light size-c34 mb-40' style={{ textAlign: "center", marginTop: "30px", color: "black" }}> Video Gallery</h3>
                        <SliderVideo />
                    </div>

                </div>
            </div>
            <br />
        </>
    )
}

export default Video